/**
 * Android Manifest Permission Checker Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ITransformerTool } from '@/interfaces/ITool';

function uniqSorted(items: string[]): string[] {
  return Array.from(new Set(items)).sort((a, b) => a.localeCompare(b));
}

export const ManifestPermissionCheckerTool: ITransformerTool = {
  id: 'manifest-permission-checker',
  name: 'Manifest Permission Checker',
  description: 'Extract Android permissions from AndroidManifest.xml',
  version: '1.0.0',
  type: 'transformer',
  category: 'Validators & Testers',
  keywords: ['android', 'manifest', 'permission', 'xml', 'uses-permission'],

  supportedInputTypes: [SEMANTIC_TYPES.XML, SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.JSON,

  attributes: [
    {
      name: 'pretty',
      type: 'boolean',
      label: 'Pretty Print',
      defaultValue: true,
      description: 'Pretty-print the JSON output',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    const text = String(input ?? '');
    const re = /<uses-permission\b[^>]*android:name\s*=\s*"([^"]+)"[^>]*\/>/gi;
    const matches: string[] = [];
    let m: RegExpExecArray | null;
    while ((m = re.exec(text))) {
      matches.push(m[1]!);
    }

    const permissions = uniqSorted(matches);
    const out = {
      count: permissions.length,
      permissions,
    };

    return config.pretty === false ? JSON.stringify(out) : JSON.stringify(out, null, 2);
  },
};
